import { stringifyQs } from "@dashboard/utils/urls";

export const sduiSection = "/sdui";

export type SduiTab = "themes" | "sections" | "configs";

export interface SduiUrlQueryParams {
  tab?: SduiTab;
  action?: "add" | "edit" | "delete";
  id?: string;
}

export const sduiPath = sduiSection;

export const sduiUrl = (params?: SduiUrlQueryParams) =>
  sduiPath + (params ? "?" + stringifyQs(params) : "");
